import Api from '../Api';

export const getDailyCompletionList = query => async dispatch => {
  const { data } = await Api.get('/daily-completion', query);
  dispatch({
    type: 'FETCH_DAILY_COMPLETION_LIST',
    payload: data,
  });
};

export const clearDailyCompletionList = () => {
  return {
    type: 'CLEAR_DAILY_COMPLETION_LIST',
  };
};
